/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Detail_Fallback_TitleInputs */



/**
* | output |
* | --- |
* | "User" |
*
* @param {User_Detail_Fallback_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_fallback_title = /** @type {((inputs?: User_Detail_Fallback_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_Fallback_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilisateur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Usuario")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Usuário")
	if (locale === "it") return /** @type {LocalizedString} */ ("Utente")
	return /** @type {LocalizedString} */ ("User")
});